module.exports = __webpack_public_path__ + "09a4608b6661f09e4063c963e346ff7b.pdf";